import React from 'react';
import style from './style.scss';
import {Link} from 'react-router-dom';
import {UploadImage} from 'components/UI/Image';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {openPopupProductDetail} from 'actions';
import {ShowIf} from 'components/utils';
import {SendRequestButton} from 'components/partials/send-request-button';
import {ShoppingCartButton} from 'components/partials/shopping-cart-button';

class Product extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    if (typeof this.props.onClick == 'undefined') {
      this.props.dispatch(openPopupProductDetail(this.props.id));
    } else {
      this.props.onClick(e);
    }
  }

  onClickButtonEditProduct() {
    this.props.onClickButtonEditFairProduct();
  }

  render() {
    return (
      <div className="product">
        <ShowIf condition={this.props.showStatus && this.props.status == 0}>
          <span className='product-status status-waiting'>Đang chờ duyệt</span>
        </ShowIf>
        <ShowIf condition={this.props.showStatus && this.props.status == 1}>
          <span className='product-status status-refuse'>Bị từ chối</span>
        </ShowIf>
        <ShowIf condition={this.props.showStatus && this.props.status == 2}>
          <span className='product-status status-success'>Đã duyệt</span>
        </ShowIf>
        <div className="wrap-img" onClick={this.onClick}>
          <UploadImage type="PRODUCT" width="177" height="127" transform="crop" image={this.props.images[this.props.images.length -1]} />
        </div>
        <div className={this.props.fixHeightContent ? 'product-wrap-detail' : ''}>
          <p className="name">
            <span onClick={this.onClick} className="product-link"><span className="name-link">{this.props.name}</span></span>
          </p>
          <ShowIf condition={this.props.showPrice}>
            <p className="price">GIÁ: {this.props.price === 'Giá tham khảo' ? "Liên hệ" : this.props.price}</p>
          </ShowIf>
          <ShowIf condition={this.props.showFairSalePrice}>
            <div>
              <p className="price-sale">300000</p>
              <p className="price-old"><span className='price-throught'>{this.props.price}</span><span className='sale-percent'>-8%</span></p>
            </div>
          </ShowIf>
          <ShowIf condition={this.props.showSalePrice}>
            <div className='sale-price'>
              <p className="price">GIÁ: 70.000 <span className="price-old"><span className='price-throught'>100.000</span><span className='sale-percent'>GIẢM: -30%</span></span></p>
            </div>
          </ShowIf>
          <ShowIf condition={this.props.showDescription}>
            <p className="description">{this.props.description}</p>
          </ShowIf>
        </div>
        <ShowIf condition={this.props.showEditButton}>
          <button type="button" className="send-request" onClick={this.onClickButtonEditProduct.bind(this)}>Chỉnh sửa</button>
        </ShowIf>
        <ShowIf condition={this.props.enableAddProduct && parseFloat(this.props.price) > 0}>
          <ShoppingCartButton productId={this.props.id} isDetail={false} />
        </ShowIf>
        <ShowIf condition={this.props.enableAddProduct && isNaN(parseFloat(this.props.price))}>
          <SendRequestButton productId={this.props.id} />
        </ShowIf>
      </div>
    );
  }
}

Product.propTypes = {
  showDescription: PropTypes.bool,
  enableAddProduct: PropTypes.bool,
  showPrice: PropTypes.bool,
  showSalePrice: PropTypes.bool,
  showFairSalePrice: PropTypes.bool,
  showEditButton: PropTypes.bool,
  fairProduct: PropTypes.bool,
  showStatus: PropTypes.bool,
  fixHeightContent: PropTypes.bool
};

Product.defaultProps = {
  showDescription: true,
  enableAddProduct: false,
  showPrice: true,
  showFairSalePrice: false,
  fixHeightContent: true,
  showSalePrice: false,
  showEditButton: false,
  fairProduct: false,
  showStatus: false
};

export default connect()(Product);



// WEBPACK FOOTER //
// ./components/partials/product/Product.jsx